export const DOMINIO_PORTAL = 'portalservicos.usp.br';